// The period labels in the language on screen (decision 0030).
//
// web/periods.js is shared with the Worker and writes English unless told
// otherwise. The app imports its labels from here instead, so every date the
// app writes itself follows the language switch without each caller passing it.
import * as periods from '../../periods.js'
import { lang } from './i18n.js'

export const windowLabel = (period, anchor) => periods.windowLabel(period, anchor, lang.value)
export const optionLabel = (period, anchor) => periods.optionLabel(period, anchor, lang.value)
export const bucketLabelFor = (period) => periods.bucketLabelFor(period, lang.value)
export const trendWindow = (period, anchor) => periods.trendWindow(period, anchor, lang.value)
export const dayRange = (anchor, days) => periods.dayRange(anchor, days, lang.value)
export const periodsFrom = (days, period) => periods.periodsFrom(days, period, lang.value)
